import { Button } from '@yellowcard/components-library-vue3';
import { defineComponent, onBeforeMount, ref } from 'vue';
import { storeToRefs } from 'pinia';
import router from '@/router';
import useTransactionsStore from '@/store/modules/transactions';
import { TransactTypes } from '@/types/transact';
import { usePaymentStore } from '@/store/modules/payment';
import { PaymentTypes } from '@/types/payment';
import TransactHeader from '@/components/transact/TransactHeader.vue';
export default defineComponent({
    name: 'CancelTransaction',
    props: {},
    components: {
        Button,
        TransactHeader,
    },
    setup() {
        const paymentsStore = usePaymentStore();
        const { currentStep: PaymentStep } = storeToRefs(paymentsStore);
        const transactionStore = useTransactionsStore();
        const { currentStep: BuyStep, markStep } = storeToRefs(transactionStore);
        const backPath = ref();
        onBeforeMount(() => {
            const backUrl = router.options.history.state.back;
            const route = router.resolve({ path: `${backUrl}` });
            backPath.value = route.path;
        });
        const onKeyPress = () => {
            console.log('key pressed');
        };
        const backClick = () => {
            BuyStep.value = markStep.value;
            if (backPath.value === '/') {
                // came from home therefore, was on buy route
                router.push('/transact');
            }
            else {
                router.push(backPath.value);
            }
        };
        const cancelTransaction = () => {
            BuyStep.value = TransactTypes.TransactSteps.BUY_1;
            PaymentStep.value = PaymentTypes.PaymentSteps.PAYMENT_1;
            transactionStore.resetStore();
            paymentsStore.resetStore();
            router.push('/');
        };
        return {
            backClick,
            cancelTransaction,
            onKeyPress,
        };
    },
});
